import React from 'react';
import Transactions from '.';

const ChargebackTransactions = () => (
  <>
    <Transactions
      title="Chargeback Transactions"
      transactionType="CHARGEBACK"
    />
  </>
);

export default ChargebackTransactions;
